cafm.scheduler = {

    bgColours: function () { return ['red', '#444444', '#00aeee']; },
    views: function () {

        return [
            { type: 'day', selected: true, selectedDateFormat: "{0:d}", dateHeaderTemplate: kendo.template('#=kendo.toString(date, "dddd dd")#'), workWeekStart: 0, workWeekEnd: 6 },
            { type: 'week', selected: false, dateHeaderTemplate: kendo.template('#=kendo.toString(date, "dddd dd")#'), workWeekStart: 0, workWeekEnd: 6 }
        ]
    },
    viewsMobile: function () {

        return [
            { type: 'day', selected: true, selectedDateFormat: '{0:d}', dateHeaderTemplate: kendo.template('#=kendo.toString(date, "dddd dd")#') }
        ]
    },
    rooms: [],
    occurrences: [],

    render: function(options){

        var schedEl = $('#' + options.ClientId);
        var eventTemplate = $('#eventTemplate').length ? $('#eventTemplate').html() : null;

        schedEl.data('options', options);
        
        var schedulerOptions = {
            autoBind: options.AutoBind,
            date: cafm.util.truncateToDate(options.StartDateTime),
            currentTimeMarker: false,
            height: cafm.panel.getContentPaneHeight() - $('#sub-header').outerHeight() - 3,
            views: cafm.scheduler.views(),
            showWorkHours: options.ShowWorkHours,
            workDayStart: cafm.util.ensureDate(options.WorkDayStart),
            workDayEnd: cafm.util.ensureDate(options.WorkDayEnd),
            allDaySlot: options.AllDaySlot,
            dataSource: cafm.ds.createSchedulerDataSource({

                element: schedEl,
                options: options
            }),
            dataBound: cafm.scheduler.schedulerDataBound,
            editable: {
                create: false,
                update: false,
                destroy: false,
                resize: true,
                move: true
            },
            eventTemplate: eventTemplate,
            mobile: isMobile,
            selectable: options.Selectable != cafm.enums.Selectable.Disabled
        }

        schedulerOptions.navigate = function (e) {
            
            if (options.EnsureCurrentDateOnRefresh) {
                e.sender.element.data('navigatedwhen', new Date());
            }
            e.sender.select(null);
        }

        if (options.OnMoveStart) {

            schedulerOptions.moveStart = cafm.util.getReference(options.OnMoveStart);
        }

        if (options.OnMoveEnd) {

            schedulerOptions.moveEnd = cafm.util.getReference(options.OnMoveEnd);
        }

        if (options.OnResizeStart) {

            schedulerOptions.resizeStart = cafm.util.getReference(options.OnResizeStart);
        }

        if (options.OnResizeEnd) {

            schedulerOptions.resizeEnd = cafm.util.getReference(options.OnResizeEnd);
        }

        var buildScheduler = function () {

            var doBuild;
            if (options.OnPreBuildControl) {

                doBuild = cafm.util.callFunction(options.OnPreBuildControl, schedulerOptions, schedEl);
            }
            else {

                doBuild = true;
            }

            if (!doBuild) {

                return;
            }
            
            schedEl = schedEl.kendoScheduler(schedulerOptions);
            var scheduler = schedEl.data('kendoScheduler');
            scheduler.element.data('options', options);

            var doFetch;
            if (options.OnPostBuildControl) {

                doFetch = cafm.util.callFunction(options.OnPostBuildControl, schedulerOptions, scheduler);
            }
            else {

                doFetch = true;
            }

            // check fetch flag
            if (doFetch) {

                scheduler.dataSource.fetch();
            }
        }

        var handlerName = options.BuildControlHandlerName;
        if (cafm.util.hasStringVal(handlerName)) {

            cafm.handlers.set(handlerName, buildScheduler);
        }
        else {

            buildScheduler();
        }
    },
    schedulerDataBound: function (args) {

        var scheduler = args.sender,
            element = scheduler.element,
            options = element.data('options'),
            handler = options.OnDataBound;

        if(handler){

            cafm.handlers.exe(handler, args);
        }
    },
    helpers: {

        hideScheduler: function (args) {

            args.scheduler.element.hide();

            if (args.showMessage) {

                var schedulerOptions = args.scheduler.element.data('options');
                $('#' + schedulerOptions.MessagePanelClientId).showMessage({

                    Title: args.message || schedulerOptions.NoItemsMessage,
                    Type: cafm.enums.MessageType.Warning
                });
            }
        },
        showScheduler: function (args) {

            if (args.hideMessage) {

                var schedulerOptions = args.scheduler.element.data('options');
                $('#' + schedulerOptions.MessagePanelClientId).hide();
            }

            args.scheduler.element.show();
        },
        viewFullScreen: function (args) {
                        
            args.scheduler.element.closest('#mainContentPane').viewFullScreen();
        }
    }
}